module.exports = __webpack_public_path__ + "img/alipay.ab946a19.png";